import { Observable } from 'rxjs/Observable'
import { combineEpics } from 'redux-observable'

import { captureException } from 'utils/SentryHelpers'

import { api } from './api'
import * as actions from './actions'

function fetchClassifications(action$) {
  return action$
    .ofType(actions.fetchClassifications.toString())
    .switchMap(() => {
      return api
        .fetch()
        .map(actions.fetchClassificationsSuccess)
        .catch(error => {
          captureException(error)
          return Observable.of(actions.fetchClassificationsFailed())
        })
    })
}

function createClassifications(action$) {
  return action$
    .ofType(actions.createClassifications.toString())
    .pluck('payload')
    .mergeMap(classifications => {
      return api
        .create(classifications)
        .map(actions.createClassificationsSuccess)
        .catch(error => {
          captureException(error)
          return Observable.of(actions.createClassificationsFailed())
        })
    })
}

export const epic = combineEpics(fetchClassifications, createClassifications)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/classification/epic.js